import React from 'react';

function Header() {
  return (
    <header className="header">
      <h1>Uniswap V3 Monitor</h1>
    </header>
  );
}

export default Header;